import { memo } from "react";
import { TableRow as UITableRow, TableCell } from "@/components/ui/table";
import { DomainCell } from "../DomainCell";
import type { EditableCellValue } from "../EditableCell";
import type { Domain } from "@/types/domain";
import type { Column } from "@/lib/table-columns";

interface TableRowProps {
  domain: Domain;
  columns: Column[];
  onUpdateDomain: (
    id: string,
    column: string,
    value: EditableCellValue,
  ) => Promise<void>;
}

export const TableRow = memo(function TableRow({
  domain,
  columns,
  onUpdateDomain,
}: TableRowProps) {
  return (
    <UITableRow className="hover:bg-muted/40">
      {columns.map((col) => (
        <TableCell
          key={`${domain.id}-${col.key}`}
          className="whitespace-nowrap border-r border-border px-4 py-3 last:border-r-0"
        >
          <DomainCell
            domain={domain}
            columnKey={col.key}
            onUpdate={onUpdateDomain}
          />
        </TableCell>
      ))}
    </UITableRow>
  );
});
